import useAPI from "@dpa-connect/dpa-id-user/store/utils/api";
import API_SETTINGS from "@/constants/apiSettings";

export default useAPI(API_SETTINGS);
